module.exports = __webpack_public_path__ + "podcast-solid-2b205bf20ff93aebb73f.svg";